import { FormTemplate } from 'data/template/template.types';

// eslint-disable-next-line import/prefer-default-export
export const collectionFunctionGroupTemplate: FormTemplate = {
  version: '1.0.0',
  name: 'Collection Function Group',
  key: 'CF_GROUP',
  main: {
    metadata: {
      layout: {
        rows: [
          [
            'id',
          ],
          [
            'name',
            'description',
          ],
          [
            'hi1endpointid',
          ],
          [
            'hi1notifyuri',
          ],
          [
            'hi1notifysecid',
          ],
          [
            'contact',
          ],
        ],
      },
    },
    fields: {
      id: {
        type: 'text',
        hide: 'true',
        initial: '',
      },
      name: {
        label: 'LEA',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 16,
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', '-_.~!@#$%^*+?'],
              errorMessage: 'Can include letters, digits and the following special characters: -_.~!@#$%^*+?. Please re-enter.',
            },
          ],
        },
      },
      description: {
        label: 'Description',
        type: 'text',
        initial: '',
        validation: {
          validators: [
            {
              type: 'length',
              length: 64,
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', 'spaces', '-_.~!@#$%^*+?'],
              errorMessage: 'Can include letters, digits, spaces and the following special characters: -_.~!@#$%^*+?. Please re-enter.',
            },
          ],
        },
      },
      hi1endpointid: {
        label: 'LEA Identifier (ETSI EndPointID)',
        type: 'text',
        initial: '',
        validation: {
          required: false,
          validators: [
            {
              type: 'length',
              length: 16,
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', '-_.~!@#$%^*+?'],
              errorMessage: 'Can include letters, digits and the following special characters: -_.~!@#$%^*+?. Please re-enter.',
            },
          ],
        },
      },
      hi1notifyuri: {
        label: 'HI1 Notification Address',
        placeholder: 'e.g. https://10.0.1:443/path',
        type: 'text',
        initial: '',
        validation: {
          required: false,
          validators: [
            {
              type: 'length',
              length: 128,
            },
            {
              type: 'URL',
              errorMessage: 'Must be a valid URL. Please re-enter.',
            },
          ],
        },
      },
      hi1notifysecid: {
        label: 'TLS Profile (Security Info ID)',
        placeholder: 'Select a Security Info ID',
        type: 'select',
        initial: '',
        options: [],
      },
      contact: {
        label: 'Contact',
        placeholder: 'Select a Contact',
        type: 'select',
        initial: '',
        options: [],
      },
    },
  },
};
